/** 쇼핑몰 포트폴리오 스크린샷 — public/portfolio/commerce/ */

function commerceSrc(filename) {
  return `/portfolio/commerce/${encodeURIComponent(filename)}`;
}

function commerceItem(id, title, filename, url) {
  return { id, title, url, src: commerceSrc(filename) };
}

export const COMMERCE_PORTFOLIO_IMAGES = [
  commerceItem("ode", "오드", "2.webp", "ode.dsite"),
  commerceItem("nike", "나이키", "8.webp", "nike.dsite"),
  commerceItem("chanel", "샤넬", "7.webp", "chanel.dsite"),
  commerceItem("hermes", "에르메스", "6.webp", "hermes.dsite"),
  commerceItem("aurora", "오로라", "5.webp", "aurora.dsite"),
  commerceItem("nomad", "노매드", "3.webp", "nomad.dsite"),
  commerceItem("softly", "소프틀리", "1.webp", "softly.dsite"),
  commerceItem("rawline", "로우라인", "4.webp", "rawline.dsite"),
  commerceItem(
    "dsitesolution",
    "DSiteSolution",
    "dsitesolution-portfolio.webp",
    "dsitesolution-portfolio.com",
  ),
];

export const DEFAULT_COMMERCE_IMAGE = COMMERCE_PORTFOLIO_IMAGES[0];
